import { Injectable, OnInit} from '@angular/core';
import { TokenManager } from './tokenManager';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environments/environment';
import { LabOrder } from './data/lab-order';
import { ReferenceListItem } from './data/reference-list-item';

import 'rxjs/add/observable/throw';
import { SearchCriteria } from './data/search-criteria';
import { SearchResult } from './data/search-result';
import { UtilsService } from './utils.service';
import { LensEnhancementDescription } from './data/lens-enhancement-description';

declare var require: any;

const jsonObj: any = require('../../assets/lens-enhancement-descriptions.json');

/**
 * This service is designed to encapsulate API calls.  Except for the LabOrderBusinessService, no other
 * class should inject this service.
 */
@Injectable()
export class LabOrderApiService implements OnInit {

  apiEndpoint: string = environment.apiEndpoint.toString();
  apiLabSearchEndpoint: string = environment.apiLabSearchEndpoint.toString();


  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  constructor(private http: HttpClient, private tokenManager: TokenManager) { }


  // Given a lab order number, return an Observable defining the lab order
  getLabOrder<LabOrder>(labOrderNumber: string): Observable<LabOrder> {
    if (labOrderNumber && labOrderNumber !== null && labOrderNumber.trim() !== '') {
      const url = this.apiEndpoint + labOrderNumber;
      return this.getLabOrderByUrl(url);
    } else {
      return Observable.throw(new Error('Null or Empty labOrderNumber for getLabOrder'));
    }
  }

  // Follow the provided url to return an Observable defining the lab order
  getLabOrderByUrl<LabOrder>(url: string): Observable<LabOrder> {
    if (url && url !== null && url.trim() !== '') {
      const httpHeaders = this.getHttpHeaders();
      console.log('Get lab order request: ' + url);
      return this.http.get<LabOrder>(url, {'headers': httpHeaders});
    } else {
      return Observable.throw(new Error('Null URL for getLabOrderByUrl'));
    }
  }

  // Get all reference lists to populate the laborder form drop-downs.
  getReferenceLists() {
    // pass in headers because token is required by web-service.
    const httpHeaders = this.getHttpHeaders();

    // don't return all reference lists until last web-service call returns.
    return Observable.forkJoin(
      this.http.get<ReferenceListItem[]>(this.apiEndpoint + 'referencelists/balancelenses', {'headers': httpHeaders} )
        .catch((error) => {
          console.warn('Error getting ' + this.apiEndpoint + 'referencelists/balancelenses - ' + error.statusText);
          // not a required field so just return empty item list.
          return Observable.of(<ReferenceListItem[]>{ });
        }),
      this.http.get<ReferenceListItem[]>(this.apiEndpoint + 'referencelists/whichlenses', {'headers': httpHeaders} )
        .catch((error) => {
          console.warn('Error getting ' + this.apiEndpoint + 'referencelists/whichlenses - ' + error.statusText);
          // not a required field so just return empty item list.
          return Observable.of(<ReferenceListItem[]>{ });
        })
    );
  }

  // Given a complete lab order, return the Observable defining the put to update the order.
  updateLabOrder(labOrder): Observable<LabOrder> {

    console.log('Update lab order request.' + this.apiEndpoint + labOrder.labOrderNumber);
    const httpHeaders = this.getHttpHeaders();

    // Just before issuing the PUT, amputate any null, undefined, or empty string properties.
    this.deleteEmptyProperties(labOrder);

    return this.http.put(this.apiEndpoint + labOrder.labOrderNumber, labOrder, {'headers': httpHeaders})
        .catch((error: any) => {
          console.log('error: ' + JSON.stringify(error));
          return Observable.throw(error);
        });
  }

  // Search for lab orders based on the given criteria
  labSearch(searchCriteria: SearchCriteria): Observable<SearchResult> {

    console.log('Lab Search request. ' + this.apiLabSearchEndpoint);
    const httpHeaders = this.getHttpHeaders();

    // Just before issuing the PUT, amputate any null, undefined, or empty string properties.
    this.deleteEmptyProperties(searchCriteria);

    return this.http.post(this.apiLabSearchEndpoint, searchCriteria, {'headers': httpHeaders})
      .catch((error: any) => {
        console.log('error: ' + JSON.stringify(error));
        return Observable.throw(error);
      });
  }

  // Search for lab orders based on the given URL
  labSearchByUrl(url: string): Observable<SearchResult> {

    console.log('Lab Search by URL request. ', url);

    if (!UtilsService.isEmpty(url)) {
      const httpHeaders = this.getHttpHeaders();
      return this.http.get(url, {'headers': httpHeaders})
        .catch((error: any) => {
          console.log('error: ' + JSON.stringify(error));
          return Observable.throw(error);
        });
    } else {
      return Observable.throw(new Error('Null URL for labSearchByUrl'));
    }
  }

  public getHttpHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('Authorization', TokenManager.token.toString())
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json');
  }


  // Take an arbitrary javascript object and parse it recursively to remove any and all
  // properties that are null, undefined, or empty string.

  deleteEmptyProperties(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (value === '' || value === undefined || value === null) {
          delete obj[key];
        } else if (typeof value === 'object') {
          this.deleteEmptyProperties(value);
        }
      }
    }
  }
  getLensEnhancementDescriptions(): Observable<LensEnhancementDescription[]> {
    return Observable.of(jsonObj);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/lab-order-api.service.ts